import { webSocket } from "rxjs/webSocket";
import { Subject } from "rxjs";
import { handleAuthError, isAuthError } from "../../../utils/auth/authErrorHandler";

class AffiliateNotificationService {
  constructor() {
    this.socket = null;
    this.socketPath = `/ws/affiliates`;
    this.messageSubject = new Subject();
    this.reconnectDelay = 3000;
    this.subscribers = new Set(); // Track active subscribers
    this.isAuthError = false; // Track if we've encountered an auth error
  }

  connect() {
    if (this.socket || this.isAuthError) return;

    const socketPath = `${process.env.REACT_APP_WS_API_DOMAIN}${this.socketPath}`;
    this.socket = webSocket(socketPath);

    this.socket.subscribe({
      next: (msg) => {
        this.messageSubject.next(msg);
      },
      error: (err) => {
        // Check if this is an authentication error
        if (isAuthError(err)) {
          this.isAuthError = true;
          this.disconnect();
          handleAuthError();
          return; // Don't reconnect on auth errors
        }
        
        this.reconnect();
      },
      complete: () => {
        if (!this.isAuthError) {
          this.reconnect();
        }
      },
    });
  }

  reconnect() {
    if (this.isAuthError) return; // Don't reconnect on auth errors
    
    if (this.socket) {
      this.socket.complete();
      this.socket = null;
    }
    setTimeout(() => this.connect(), this.reconnectDelay);
  }

  disconnect() {
    if (this.socket && this.subscribers.size === 0) {
      this.socket.complete();
      this.socket = null;
      this.messageSubject.complete(); // Ensure cleanup
    }
  }

  subscribe(callback) {
    this.subscribers.add(callback);
    this.connect();

    const subscription = this.messageSubject.subscribe(callback);

    return () => {
      subscription.unsubscribe();
      this.subscribers.delete(callback);
      this.disconnect(); // Close if no subscribers remain
    };
  }

  getMessages() {
    this.connect();
    return this.messageSubject.asObservable();
  }
}

export default AffiliateNotificationService;